import React from 'react'
import {Pagination} from 'antd'

interface IProps {
    className?: string
    totalPage: number
    onPageChange?: (e?: any) => void
    currentPage?: number
    isScrollTop?: boolean
}

const WizPagination: React.FC<IProps> = ({className, totalPage, currentPage, onPageChange, isScrollTop = true}) => {
    return (
        <div className={`mt-[30px] flex justify-end ${className}`}>
            <Pagination
                showSizeChanger={false}
                defaultCurrent={1}
                total={totalPage}
                onChange={e => {
                    onPageChange(e)
                    isScrollTop && window.scrollTo({top: 0})
                }}
                current={currentPage}
            />
        </div>
    )
}

export default WizPagination
